/**
 * Meze hromadného nahrávání fotek (vize podnety-tymu-2026-10, F7.8–F7.10, řez 04): kdy
 * prohlížeč soubor před odesláním zmenší, co server odmítne (limity vstupu Images binding)
 * a kolik otisků bere jedna kontrola duplicit. Čtou je admin (rozhodnutí o zmenšení, dělení
 * kontroly po částech) i API (odmítnutí souboru, schéma těla `check-hashes`).
 */

/** Prohlížeč zmenší soubor s delší stranou nad touto hodnotou (F7.8). */
export const BROWSER_RESIZE_MAX_EDGE_PX = 6000;
/** … nebo soubor nad tolik bajtů (F7.8 „nad 20 MB“; o něco pod limitem Images). */
export const BROWSER_RESIZE_MAX_BYTES = 20_000_000;
/** Kvalita JPEG zmenšení a nižší stupně, když výsledek přesáhne `BROWSER_RESIZE_MAX_BYTES`. */
export const BROWSER_RESIZE_JPEG_QUALITY_STEPS = [0.92, 0.85, 0.75] as const;
/** Limity vstupu Images binding (vize §6): server soubor nad nimi odmítne. */
export const IMAGES_INPUT_MAX_BYTES = 20 * 1024 * 1024;
export const IMAGES_INPUT_MAX_EDGE_PX = 12_000;
export const IMAGES_INPUT_MAX_PIXELS = 100_000_000;
/** Nejvýš otisků v jednom `POST /upload/check-hashes` (technická mez těla; panel dělí po částech). */
export const MEDIA_HASH_CHECK_MAX = 200;
